import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot } from "vue"

import { provide } from 'vue'
import { SessionRegistryStoreKey } from './SessionRegistryStore.interfaces'
import { createSessionRegistryStore } from './SessionRegistryStore.composition'


export default /*#__PURE__*/_defineComponent({
  __name: 'SessionRegistryStore',
  setup(__props) {

const sessionRegistryStore = createSessionRegistryStore()
provide(SessionRegistryStoreKey, sessionRegistryStore)

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", { store: _unref(sessionRegistryStore) })
}
}

})